import { ScrubbingDirection } from '@dtvgo/progress-bar';

import platform from '../../../../utils/platform';

export const KeyCodeToScrubbingDirection = {
  [platform.keyCodes.navigation.left]: ScrubbingDirection.BACKWARD,
  [platform.keyCodes.navigation.right]: ScrubbingDirection.FORWARD,
};
